import React, { createContext, useContext } from 'react';
import type { SessionUser } from '../types/auth';

export interface JobIslandPageContext {
  locale: string;
  pathname: string;
  urlOriginal: string;
  user: SessionUser | null;
}

const JobIslandContext = createContext<JobIslandPageContext | null>(null);

export function useJobIslandContext(): JobIslandPageContext | null {
  return useContext(JobIslandContext);
}

export const JobIslandProvider = JobIslandContext.Provider;
